import React from 'react';
import { MessageSquare, TrendingUp, FileText } from 'lucide-react';
import type { FunilIaStageSlug } from '../funilIaStage';
import type { Lead } from '../../../types';
import { FUNIL_IA_HUMAN_ACCENT } from '../engine/constants';

interface FunilIaStatsProps {
  grouped: Record<FunilIaStageSlug, Lead[]>;
}

const STAT_CONFIG: Array<{
  slug: FunilIaStageSlug;
  label: string;
  tone: string;
  icon: React.ElementType;
  color: string;
}> = [
  { slug: 'inicio', label: 'Inicial', tone: 'start', icon: MessageSquare, color: '#6366F1' },
  { slug: 'em_negociacao_ia', label: 'Negociação', tone: 'nego', icon: TrendingUp, color: '#A855F7' },
  // Slug `proposta_ia` mantido p/ compat com dados; label = "Coletando dados".
  { slug: 'proposta_ia', label: 'Coletando dados', tone: 'prop', icon: FileText, color: '#10B981' },
];

/** Cores = barra de etapa; rótulos alinhados à legenda do protótipo. */
const STAGE_COLOR_LEGEND: Array<{ id: string; label: string; color: string }> = [
  { id: 'inicio', label: 'IA Início', color: '#6366F1' },
  { id: 'em_negociacao_ia', label: 'Negociação', color: '#A855F7' },
  { id: 'proposta_ia', label: 'Coletando dados', color: '#10B981' },
  { id: 'humano', label: 'Humano', color: FUNIL_IA_HUMAN_ACCENT },
];

export const FunilIaStats: React.FC<FunilIaStatsProps> = ({ grouped }) => (
  <div className="funil-ia-stats-block">
    <div className="funil-ia-stats" role="list">
      {STAT_CONFIG.map(({ slug, label, tone, icon: Icon, color }) => (
        <div key={slug} className={`funil-ia-stat funil-ia-stat--${tone}`} role="listitem">
          <div className="funil-ia-stat-row">
            <span className="funil-ia-stat-ico" style={{ color }}>
              <Icon size={18} />
            </span>
            <span>{label}</span>
          </div>
          <div className="funil-ia-stat-big">{grouped[slug].length}</div>
        </div>
      ))}
    </div>
    <div className="funil-ia-stats-legend" aria-label="Cores por etapa e alvo humano" role="list">
      {STAGE_COLOR_LEGEND.map(({ id, label, color }) => (
        <div key={id} className="funil-ia-legend-item" role="listitem">
          <span
            className="funil-ia-legend-dot"
            style={{ background: `radial-gradient(circle at 32% 28%, ${color}, ${color} 60%)` }}
            aria-hidden
          />
          <span className="funil-ia-legend-label">{label}</span>
        </div>
      ))}
    </div>
  </div>
);
